import React from 'react';
function Layout(props) {
  return (
    <React.Fragment>

      <header>
        <div className='logo'>
          <h1>
            Rick and Morty <br />
            <span>
              Versus
            </span>
          </h1>
        </div>
      </header>

      <main>
        {props.children}
      </main>

      <footer>
      </footer>
    </React.Fragment>
  );
}
export default Layout;